import DashboardMenuComponent from './dashboard-menu.component';

import { useCallback, useState } from 'react';
import { CLCustomButton } from '../ui-controls';

export default function DashboardHamburgerMenuComponent() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // Toggle hamburger
  const toggleHamburger = () => {
    setIsOpen(!isOpen);
  };

  // Close Hamburger callback
  const closeHamburger = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <CLCustomButton
        className="flex justify-center items-center p-2"
        onClick={() => toggleHamburger()}
      >
        {/* Hamburger */}
        <div className="space-y-1">
          <div className="w-5 h-0.5 bg-gray-700 rounded-lg"></div>
          <div className="w-5 h-0.5 bg-gray-700 rounded-lg"></div>
          <div className="w-5 h-0.5 bg-gray-700 rounded-lg"></div>
        </div>
      </CLCustomButton>

      {/* Body */}
      <div className="block md:hidden">
        {isOpen && (
          <>
            {/* Transparent Background */}
            <div
              className="fixed top-0 left-0 h-full w-full bg-black bg-opacity-75 z-50"
              onClick={() => toggleHamburger()}
            >
              {/* Close icon */}
              <div className="fixed top-4 right-4">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L8 6.58579L14.2929 0.292893C14.6834 -0.0976311 15.3166 -0.0976311 15.7071 0.292893C16.0976 0.683417 16.0976 1.31658 15.7071 1.70711L9.41421 8L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L8 9.41421L1.70711 15.7071C1.31658 16.0976 0.683417 16.0976 0.292893 15.7071C-0.0976311 15.3166 -0.0976311 14.6834 0.292893 14.2929L6.58579 8L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>

            {/* Menu */}
            <div className="fixed top-0 left-0 h-full w-10/12 bg-black z-50">
              <div className="h-full w-full overflow-y-auto cl_secondary_background">
                <DashboardMenuComponent
                  closeHamburger={closeHamburger}
                ></DashboardMenuComponent>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
